// Holidays Data
// Content is now managed in Sanity. This file re-exports the generated JSON
// (src/cms/holidays.json) so existing imports keep working unchanged.
// To edit: use the Sanity Studio "Holiday" documents, then rebuild.
import holidaysData from '../../cms/holidays.json';

export default holidaysData;
